var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.778 8.17495L2.3843 13.8915C1.99387 14.1062 1.53878 13.7416 1.66324 13.3137L3.28561 7.73684L1.66324 2.15995C1.53878 1.7321 1.99387 1.36744 2.3843 1.58217L12.778 7.29873C13.1234 7.4887 13.1234 7.98499 12.778 8.17495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28561 7.73684L1.66324 2.15995C1.53878 1.7321 1.99387 1.36744 2.3843 1.58217L12.778 7.29873C13.1234 7.4887 13.1234 7.98499 12.778 8.17495L2.3843 13.8915C1.99387 14.1062 1.53878 13.7416 1.66324 13.3137L3.28561 7.73684ZM3.28561 7.73684L7.20523 7.73684",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.73633L6.38947 7.73633",
    stroke: "#25A4DB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionArrow);
export default __webpack_public_path__ + "static/media/OptionArrow.87735486874221af53a65be38ccbd37e.svg";
export { ForwardRef as ReactComponent };